import React from 'react';

const WelcomePhase = ({ onNext, t }) => {
  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-6 text-left">
      <h1 className="text-3xl font-semibold text-gray-800 mb-4">{t.title}</h1>
      <p className="text-gray-600 text-md mb-6">{t.description}</p>
      <button
        onClick={onNext}
        className="w-full font-bold bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-500"
      >
        {t.button}
      </button>
    </div>
  );
};

export default WelcomePhase;
